import type { FileId, PrincipalId } from '../ids'
import type { ScopeSnapshot } from './types'
import { Context, Effect, Layer } from 'effect'

/**
 * The one read `authorize` performs (PRD-019 §6.3: "pure over its inputs plus one read of
 * principal_scope"). The API binds this to scope_files_for / scope_clusters_for; tests bind an
 * in-memory map.
 */
export class ScopeReader extends Context.Tag('@gallop/domain/ScopeReader')<
  ScopeReader,
  {
    readonly scopeFor: (principalId: PrincipalId) => Effect.Effect<ScopeSnapshot>
  }
>() {}

export const emptyScope: ScopeSnapshot = {
  files: [],
  clusters: [],
  deniedFileIds: new Set<FileId>(),
  deniedClusterIds: new Set(),
}

/** Test and prototype layer: a fixed map of principal → snapshot. Unknown principals get an empty scope. */
export function inMemoryScopeReader(scopes: ReadonlyMap<PrincipalId, ScopeSnapshot>) {
  return Layer.succeed(ScopeReader, {
    scopeFor: principalId => Effect.succeed(scopes.get(principalId) ?? emptyScope),
  })
}
